import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Container,
  Typography,
  Stack,
  useMediaQuery,
  Button,
} from "@mui/material";
import DepositList from "../../components/deposit/DepositList";
import { parseCurrency } from "../../utils/tableFunctions";
import { getSDDetails, getSDMerchantDetails } from "../../services/deposit";
import { Close } from "@mui/icons-material";

export const DepositDetails = () => {
  const [holdingAmnt, setHoldingAmnt] = useState({});
  const [details, setDetails] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [loadedAmt, setLoadedAmt] = useState(false);
  const mobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handleButtonClick = () => {
    window.close();
  };

  const { id, currency } = useParams();
  useEffect(() => {
    getSDMerchantDetails(id, currency, setDetails, setLoaded);
  }, [id, currency]);

  const totalAmountHeld = () => {
    var str = "Total Amount Held: ";
    Object.keys(holdingAmnt).map((key) => {
      return (str += key + " " + parseCurrency(holdingAmnt[key]) + " | ");
    });
    return str.slice(0, str.length - 2);
  };

  return (
    <Container>
      <Stack
        direction="row"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h3" sx={{ mb: 4 }}>
          Deposits Details
        </Typography>
        <Button
          startIcon={<Close />}
          variant="outlined"
          onClick={handleButtonClick}
          sx={{ height: "100%" }}
        >
          Back
        </Button>
      </Stack>
      {loaded && details.results.length > 0 ? (
        <>
          <Typography variant={mobile ? "subtitle2" : "h5"} sx={{ mb: 2 }}>
            Merchant Name: {details.results[0].merchant?.name}
          </Typography>
          <Typography variant={mobile ? "subtitle2" : "h5"} sx={{ mb: 2 }}>
            {loadedAmt && totalAmountHeld()}
          </Typography>
          <DepositList
            getAmount={setHoldingAmnt}
            table={details}
            setLoadedAmt={setLoadedAmt}
          />
        </>
      ) : (
        <Typography>Record cannot be shown.</Typography>
      )}
    </Container>
  );
};
